
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 206 206","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"stroke-dasharray":"1000","stroke-dashoffset":"1000","stroke":"#FFF","cx":"102","cy":"102","r":"102","transform":"translate(1 1)","fill":"none"}}),_c('path',{attrs:{"d":"M90.889 90.889v23.006l23.006-11.504z","fill":"#FFF"}})])
          )
        }
      }
    